import { render } from "./KYCStatusModal.vue?vue&type=template&id=04dfdff8&scoped=true"
import script from "./KYCStatusModal.vue?vue&type=script&lang=js"
export * from "./KYCStatusModal.vue?vue&type=script&lang=js"

import "./KYCStatusModal.vue?vue&type=style&index=0&id=04dfdff8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dfdff8"]])

export default __exports__